import React, { useEffect, useState, Component } from 'react';
import { Check, Edit, Trash2, X, BookOpen, PenLine, Video, Clock, FileText } from 'lucide-react';
import { useProgramContext } from '../contexts/ProgramContext';
import { DERS_RENKLERI } from '../utils/constants';
interface ScheduleItem {
  id: string;
  activityType: string;
  subject: string;
  startTime: string;
  endTime: string;
  questionCount?: number;
  notes?: string;
  completed: boolean;
  isInstitutional?: boolean; // Indicates if this is a fixed institutional class
}
// Edit Modal Component
function EditModal({
  item,
  day,
  onClose,
  onSave
}: {
  item: ScheduleItem | null;
  day: string;
  onClose: () => void;
  onSave: (day: string, item: ScheduleItem) => void;
}) {
  const [editedItem, setEditedItem] = useState<ScheduleItem | null>(item);
  if (!editedItem) return null;
  const handleChange = (field: string, value: any) => {
    setEditedItem(prev => {
      if (!prev) return null;
      return {
        ...prev,
        [field]: value
      };
    });
  };
  const handleSave = () => {
    if (editedItem) {
      onSave(day, editedItem);
      onClose();
    }
  };
  // Available time slots for selection
  const timeSlots = Array.from({
    length: 24
  }, (_, i) => {
    const hour = i.toString().padStart(2, '0');
    return `${hour}:00`;
  });
  // LGS müfredatına uygun dersler
  const subjects = ['TÜRKÇE', 'MATEMATİK', 'FEN BİLİMLERİ', 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK', 'İNGİLİZCE', 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ'];
  const activityTypes = [{
    id: 'study',
    label: 'Konu Çalışma'
  }, {
    id: 'practice',
    label: 'Soru Çözüm'
  }, {
    id: 'exam',
    label: 'Deneme'
  }, {
    id: 'video',
    label: 'Video İzleme'
  }, {
    id: 'resource',
    label: 'Kaynak Çalışması'
  }, {
    id: 'test',
    label: 'Test Çözümü'
  }, {
    id: 'homework',
    label: 'Ödev Yapma'
  }];
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50 overflow-y-auto" data-id="element-1194">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-xl" data-id="element-1195">
        <div className="relative bg-black/90 rounded-xl" data-id="element-1196">
          <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-1197">
            <h2 className="text-xl font-bold" data-id="element-1198">Programı Düzenle</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1199">
              <X className="w-6 h-6" data-id="element-1200" />
            </button>
          </div>
          <div className="p-6 space-y-4" data-id="element-1201">
            <div className="space-y-2" data-id="element-1202">
              <label className="text-sm font-medium text-gray-300" data-id="element-1203">
                Aktivite Tipi
              </label>
              <select value={editedItem.activityType} onChange={e => handleChange('activityType', e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-3" style={{
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              appearance: 'none',
              backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 1rem center',
              backgroundSize: '1em'
            }} data-id="element-1204">
                {activityTypes.map(type => <option key={type.id} value={type.id} data-id="element-1205">
                    {type.label}
                  </option>)}
              </select>
            </div>
            <div className="space-y-2" data-id="element-1206">
              <label className="text-sm font-medium text-gray-300" data-id="element-1207">Ders</label>
              <select value={editedItem.subject} onChange={e => handleChange('subject', e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-3" style={{
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              appearance: 'none',
              backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 1rem center',
              backgroundSize: '1em'
            }} data-id="element-1208">
                {subjects.map(subject => <option key={subject} value={subject} data-id="element-1209">
                    {subject}
                  </option>)}
              </select>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-1210">
              <div className="space-y-2" data-id="element-1211">
                <label className="text-sm font-medium text-gray-300" data-id="element-1212">
                  Başlangıç Saati
                </label>
                <select value={editedItem.startTime} onChange={e => handleChange('startTime', e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-3" style={{
                WebkitAppearance: 'none',
                MozAppearance: 'none',
                appearance: 'none',
                backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 0.5rem center',
                backgroundSize: '1em'
              }} data-id="element-1213">
                  {timeSlots.map(time => <option key={time} value={time} data-id="element-1214">
                      {time}
                    </option>)}
                </select>
              </div>
              <div className="space-y-2" data-id="element-1215">
                <label className="text-sm font-medium text-gray-300" data-id="element-1216">
                  Bitiş Saati
                </label>
                <select value={editedItem.endTime} onChange={e => handleChange('endTime', e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-3" style={{
                WebkitAppearance: 'none',
                MozAppearance: 'none',
                appearance: 'none',
                backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 0.5rem center',
                backgroundSize: '1em'
              }} data-id="element-1217">
                  {timeSlots.map(time => <option key={time} value={time} data-id="element-1218">
                      {time}
                    </option>)}
                </select>
              </div>
            </div>
            {editedItem.activityType !== 'study' && <div className="space-y-2" data-id="element-1219">
                <label className="text-sm font-medium text-gray-300" data-id="element-1220">
                  Soru Sayısı
                </label>
                <input type="number" min="0" value={editedItem.questionCount || ''} onChange={e => handleChange('questionCount', parseInt(e.target.value) || 0)} className="w-full bg-white/5 text-white rounded-lg px-4 py-3" data-id="element-1221" />
              </div>}
            <div className="space-y-2" data-id="element-1222">
              <label className="text-sm font-medium text-gray-300" data-id="element-1223">
                Notlar
              </label>
              <textarea value={editedItem.notes || ''} onChange={e => handleChange('notes', e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-3 min-h-[100px]" placeholder="Notlarınızı buraya ekleyin..." data-id="element-1224" />
            </div>
          </div>
          <div className="p-4 border-t border-gray-800 flex justify-end gap-3" data-id="element-1225">
            <button onClick={onClose} className="px-4 py-2 bg-transparent border border-gray-700 hover:bg-white/5 text-gray-300 rounded-lg transition-colors" data-id="element-1226">
              İptal
            </button>
            <button onClick={handleSave} className="px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 text-white rounded-lg hover:from-purple-700 hover:to-indigo-700 transition-colors" data-id="element-1227">
              Kaydet
            </button>
          </div>
        </div>
      </div>
    </div>;
}
// Confirmation Dialog Component
function ConfirmDialog({
  isOpen,
  message,
  onConfirm,
  onCancel
}: {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-1228">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-md" data-id="element-1229">
        <div className="relative bg-black/90 rounded-xl" data-id="element-1230">
          <div className="p-6" data-id="element-1231">
            <h3 className="text-lg font-medium mb-4" data-id="element-1232">{message}</h3>
            <div className="flex justify-end gap-3" data-id="element-1233">
              <button onClick={onCancel} className="px-4 py-2 bg-transparent border border-gray-700 hover:bg-white/5 text-gray-300 rounded-lg transition-colors" data-id="element-1234">
                İptal
              </button>
              <button onClick={onConfirm} className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors" data-id="element-1235">
                Evet, Kaldır
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export function TodaySchedule() {
  const [todaySchedule, setTodaySchedule] = useState<ScheduleItem[]>([]);
  const {
    gorevler,
    toggleGorevDurumu,
    gorevSil
  } = useProgramContext();
  const [editingItem, setEditingItem] = useState<ScheduleItem | null>(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<string | null>(null);
  // Kurum dersleri (sabit, düzenlenemez dersler)
  const institutionalClasses: Record<string, ScheduleItem[]> = {
    Pazartesi: [{
      id: 'inst-1',
      activityType: 'study',
      subject: 'MATEMATİK',
      startTime: '09:00',
      endTime: '10:30',
      notes: 'Okul dersi - Matematik',
      completed: false,
      isInstitutional: true
    }, {
      id: 'inst-2',
      activityType: 'study',
      subject: 'TÜRKÇE',
      startTime: '10:45',
      endTime: '12:15',
      notes: 'Okul dersi - Türkçe',
      completed: false,
      isInstitutional: true
    }],
    Çarşamba: [{
      id: 'inst-3',
      activityType: 'study',
      subject: 'FEN BİLİMLERİ',
      startTime: '13:00',
      endTime: '14:30',
      notes: 'Okul dersi - Fen Bilimleri',
      completed: false,
      isInstitutional: true
    }],
    Cuma: [{
      id: 'inst-4',
      activityType: 'exam',
      subject: 'İNGİLİZCE',
      startTime: '15:00',
      endTime: '16:30',
      notes: 'İngilizce konuşma kulübü',
      completed: false,
      isInstitutional: true
    }]
  };
  const today = new Date().toLocaleString('tr-TR', {
    weekday: 'long'
  });
  useEffect(() => {
    // Yerel depolamadan yükle
    const savedSchedule = localStorage.getItem('schedule');
    let localSchedule: ScheduleItem[] = [];
    if (savedSchedule) {
      const allSchedule = JSON.parse(savedSchedule);
      localSchedule = allSchedule[today] || [];
    }
    // Context'ten bugünkü görevleri filtrele
    const todaysContextTasks = gorevler.filter(gorev => gorev.gun === today);
    // Context'teki görevleri ScheduleItem formatına dönüştür
    const contextSchedule = todaysContextTasks.map(gorev => {
      const [startTime, endTime] = gorev.saatAraligi.split('-');
      return {
        id: gorev.id,
        activityType: gorev.etkinlikTipi || 'study',
        subject: gorev.dersAdi,
        startTime,
        endTime,
        notes: gorev.notlar,
        completed: gorev.tamamlandi || false
      };
    });
    // Kurum derslerini ekle
    const instClasses = institutionalClasses[today] || [];
    // Tüm kaynakları birleştir ve saat sırasına göre sırala
    const allItems = [...localSchedule, ...contextSchedule, ...instClasses].sort((a, b) => a.startTime.localeCompare(b.startTime));
    setTodaySchedule(allItems);
  }, [today, gorevler]);
  const handleToggleCompletion = (id: string) => {
    // Kurum dersi mi kontrol et
    const isInst = todaySchedule.find(item => item.id === id)?.isInstitutional;
    if (isInst) return; // Kurum derslerinin durumunu değiştirme
    // Önce local storage'daki görevleri kontrol et
    const savedSchedule = localStorage.getItem('schedule');
    if (savedSchedule) {
      const allSchedule = JSON.parse(savedSchedule);
      const todayItems = allSchedule[today] || [];
      const foundItem = todayItems.find((item: ScheduleItem) => item.id === id);
      if (foundItem) {
        // Local storage'daki görevi güncelle
        const updatedTodaySchedule = todayItems.map((item: ScheduleItem) => item.id === id ? {
          ...item,
          completed: !item.completed
        } : item);
        const newSchedule = {
          ...allSchedule,
          [today]: updatedTodaySchedule
        };
        localStorage.setItem('schedule', JSON.stringify(newSchedule));
        // UI'ı güncelle
        setTodaySchedule(prev => prev.map(item => item.id === id ? {
          ...item,
          completed: !item.completed
        } : item));
      } else {
        // Context'teki görevi güncelle
        toggleGorevDurumu(id);
        // UI'ı güncelle
        setTodaySchedule(prev => prev.map(item => item.id === id ? {
          ...item,
          completed: !item.completed
        } : item));
      }
    } else {
      // Context'teki görevi güncelle
      toggleGorevDurumu(id);
      // UI'ı güncelle
      setTodaySchedule(prev => prev.map(item => item.id === id ? {
        ...item,
        completed: !item.completed
      } : item));
    }
  };
  const handleEditTask = (item: ScheduleItem) => {
    if (item.isInstitutional) return; // Prevent editing institutional classes
    setEditingItem(item);
  };
  const handleSaveEdit = (day: string, updatedItem: ScheduleItem) => {
    // Update in local storage
    const savedSchedule = localStorage.getItem('schedule');
    if (savedSchedule) {
      const allSchedule = JSON.parse(savedSchedule);
      const todayItems = allSchedule[today] || [];
      const isLocalItem = todayItems.some((item: ScheduleItem) => item.id === updatedItem.id);
      if (isLocalItem) {
        // Update local storage
        const updatedTodaySchedule = todayItems.map((item: ScheduleItem) => item.id === updatedItem.id ? updatedItem : item);
        const newSchedule = {
          ...allSchedule,
          [today]: updatedTodaySchedule
        };
        localStorage.setItem('schedule', JSON.stringify(newSchedule));
      }
    }
    // Update UI
    setTodaySchedule(prev => prev.map(item => item.id === updatedItem.id ? updatedItem : item));
    // Close modal
    setEditingItem(null);
  };
  const confirmRemoveTask = (id: string) => {
    // Check if it's an institutional class
    const isInst = todaySchedule.find(item => item.id === id)?.isInstitutional;
    if (isInst) return; // Prevent deleting institutional classes
    setItemToDelete(id);
    setShowConfirmDialog(true);
  };
  const handleRemoveTask = () => {
    if (!itemToDelete) return;
    // Check if item exists in local storage
    const savedSchedule = localStorage.getItem('schedule');
    if (savedSchedule) {
      const allSchedule = JSON.parse(savedSchedule);
      const todayItems = allSchedule[today] || [];
      const isLocalItem = todayItems.some((item: ScheduleItem) => item.id === itemToDelete);
      if (isLocalItem) {
        // Remove from local storage
        const updatedTodaySchedule = todayItems.filter((item: ScheduleItem) => item.id !== itemToDelete);
        const newSchedule = {
          ...allSchedule,
          [today]: updatedTodaySchedule
        };
        localStorage.setItem('schedule', JSON.stringify(newSchedule));
      } else {
        // Remove from context
        gorevSil(itemToDelete);
      }
    } else {
      // Remove from context
      gorevSil(itemToDelete);
    }
    // Update UI
    setTodaySchedule(prev => prev.filter(item => item.id !== itemToDelete));
    // Close dialog
    setShowConfirmDialog(false);
    setItemToDelete(null);
  };
  // Get activity icon based on type
  const getActivityIcon = (type: string) => {
    switch (type) {
      case 'homework':
        return FileText;
      case 'practice':
        return PenLine;
      case 'exam':
        return FileText;
      case 'video':
        return Video;
      case 'resource':
        return BookOpen;
      case 'test':
        return PenLine;
      case 'study':
      default:
        return BookOpen;
    }
  };
  // Get activity label based on type
  const getActivityLabel = (type: string) => {
    switch (type) {
      case 'homework':
        return 'Ödev Yapma';
      case 'practice':
        return 'Soru Çözüm';
      case 'exam':
        return 'Deneme';
      case 'video':
        return 'Video İzleme';
      case 'resource':
        return 'Kaynak Çalışması';
      case 'test':
        return 'Test Çözümü';
      case 'study':
      default:
        return 'Konu Çalışma';
    }
  };
  // Normalize subject name to ensure consistent color mapping
  const normalizeSubjectName = (subject: string) => {
    const subjectUpper = subject.toUpperCase();
    // Handle different variations of subject names
    if (subjectUpper.includes('TÜRKÇE') || subjectUpper.includes('TURKCE')) return 'TÜRKÇE';
    if (subjectUpper.includes('MATEMATİK') || subjectUpper.includes('MATEMATIK')) return 'MATEMATİK';
    if (subjectUpper.includes('FEN')) return 'FEN BİLİMLERİ';
    if (subjectUpper.includes('İNKILAP') || subjectUpper.includes('INKILAP') || subjectUpper.includes('TARİH')) return 'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK';
    if (subjectUpper.includes('İNGİLİZCE') || subjectUpper.includes('INGILIZCE')) return 'İNGİLİZCE';
    if (subjectUpper.includes('DİN') || subjectUpper.includes('DIN')) return 'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ';
    return subject;
  };
  return <div className="space-y-4" data-id="element-1236">
      <h2 className="text-xl font-semibold" data-id="element-1237">Bugün Programda Ne Var?</h2>

      <div className="space-y-4" data-id="element-1238">
        {todaySchedule.map(item => {
        const Icon = getActivityIcon(item.activityType);
        const normalizedSubject = normalizeSubjectName(item.subject);
        const gradientClass = DERS_RENKLERI[normalizedSubject] || 'from-indigo-600 to-purple-600';
        // Institutional classes have a different style
        if (item.isInstitutional) {
          return <div key={item.id} className={`p-4 rounded-lg bg-gradient-to-r ${gradientClass} ${item.completed ? 'opacity-60' : ''}`} data-id="element-1239">
                <div className="flex items-center justify-between mb-2" data-id="element-1240">
                  <h3 className="text-lg font-semibold" data-id="element-1241">{item.subject}</h3>
                  <span className="text-sm text-white/90" data-id="element-1242">
                    {item.startTime.substring(0, 5)} -{' '}
                    {item.endTime.substring(0, 5)}
                  </span>
                </div>
                <div className="flex items-center gap-2 text-sm text-white/80" data-id="element-1243">
                  <Icon className="w-4 h-4" data-id="element-1244" />
                  <span data-id="element-1245">Kurum Dersi</span>
                </div>
                {item.notes && <div className="mt-2 text-sm text-white/70" data-id="element-1246">{item.notes}</div>}
              </div>;
        }
        // Personal study sessions have a different style - with dark background and colored border
        return <div key={item.id} className={`relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r ${gradientClass} ${item.completed ? 'opacity-60' : ''} group hover:shadow-[0_0_10px_rgba(255,255,255,0.2)] transition-all duration-300`} data-id="element-1247">
              <div className="bg-black/90 p-4 rounded-lg" data-id="element-1248">
                {/* Action Buttons - Visible on hover */}
                <div className="absolute top-2 right-2 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-1249">
                  <button className="p-1.5 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors" title="Düzenle" onClick={() => handleEditTask(item)} data-id="element-1250">
                    <Edit className="w-3.5 h-3.5" data-id="element-1251" />
                  </button>
                  <button className="p-1.5 rounded-full bg-white/10 hover:bg-red-500/20 text-white hover:text-red-400 transition-colors" title="Programdan Kaldır" onClick={() => confirmRemoveTask(item.id)} data-id="element-1252">
                    <Trash2 className="w-3.5 h-3.5" data-id="element-1253" />
                  </button>
                </div>

                <div className="flex items-center mb-4" data-id="element-1254">
                  <button onClick={() => handleToggleCompletion(item.id)} className={`w-6 h-6 rounded-full flex items-center justify-center transition-colors mr-3 ${item.completed ? 'bg-green-500 text-white' : 'bg-white/10'}`} data-id="element-1255">
                    {item.completed && <Check className="w-4 h-4" data-id="element-1256" />}
                  </button>
                  <div data-id="element-1257">
                    <h3 className={`text-lg font-semibold ${item.completed ? 'line-through text-gray-400' : ''}`} data-id="element-1258">
                      {item.subject}
                    </h3>
                    {/* Görev konusu varsa göster */}
                    {gorevler.find(g => g.id === item.id)?.konuAdi && <p className="text-sm text-gray-400" data-id="element-1259">
                        {gorevler.find(g => g.id === item.id)?.konuAdi}
                      </p>}
                  </div>
                </div>

                <div className="space-y-4" data-id="element-1260">
                  <div className="space-y-2" data-id="element-1261">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2" data-id="element-1262">
                      <span className="text-gray-400 flex items-center gap-2" data-id="element-1263">
                        <Icon className="w-4 h-4 text-purple-400" data-id="element-1264" />
                        {getActivityLabel(item.activityType)}
                      </span>
                      <span className="text-sm text-gray-300" data-id="element-1265">
                        {item.startTime} - {item.endTime}
                      </span>
                    </div>
                    {/* Enhanced activity details based on type */}
                    {item.activityType === 'video' && gorevler.find(g => g.id === item.id)?.videoDetay && <div className="text-sm text-gray-400" data-id="element-1266">
                          {gorevler.find(g => g.id === item.id)?.videoDetay}
                        </div>}
                    {item.activityType === 'resource' && gorevler.find(g => g.id === item.id)?.kaynakDetay && <div className="text-sm text-gray-400" data-id="element-1267">
                          {gorevler.find(g => g.id === item.id)?.kaynakDetay}
                        </div>}
                    {item.activityType === 'test' && (gorevler.find(g => g.id === item.id)?.testDetay || item.questionCount > 0) && <div className="text-sm text-gray-400" data-id="element-1268">
                          {gorevler.find(g => g.id === item.id)?.testDetay || `${item.questionCount} Soru`}
                        </div>}
                    {item.notes && <div className="text-sm text-gray-400 mt-2" data-id="element-1269">
                        Not: {item.notes}
                      </div>}
                  </div>
                </div>
              </div>
            </div>;
      })}

        {todaySchedule.length === 0 && <div className="text-center py-8 text-gray-400" data-id="element-1270">
            Bugün için planlanmış aktivite bulunmuyor
          </div>}
      </div>

      {/* Edit Modal */}
      {editingItem && <EditModal item={editingItem} day={today} onClose={() => setEditingItem(null)} onSave={handleSaveEdit} data-id="element-1271" />}

      {/* Confirmation Dialog */}
      <ConfirmDialog isOpen={showConfirmDialog} message="Bu etkinliği programdan kaldırmak istediğinize emin misiniz?" onConfirm={handleRemoveTask} onCancel={() => {
      setShowConfirmDialog(false);
      setItemToDelete(null);
    }} data-id="element-1272" />

      <style jsx global data-id="element-1273">{`
        select option {
          background-color: #1a1a1a;
          color: white;
        }
        select option:hover,
        select option:focus,
        select option:active,
        select option:checked {
          background-color: #6d28d9 !important;
          color: white !important;
        }
      `}</style>
    </div>;
}